import { makeStyles, Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { TextField, useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	separator: {
		marginRight: theme.spacing(1),
		marginLeft: theme.spacing(1),
	},
	textField: {
		fontWeight: "bold",
	},
}));

const UserPaymentField = ({ record, ...props }) => {
	const translate = useTranslate();
	const userPaymentRecord = get(record, "user_payment");
	const classes = useStyles();
	if (!userPaymentRecord) {
		return (
			<TextField
				{...props}
				source="name"
				record={{
					name: translate("resources.user-wtrs.fields.user_payment.none"),
				}}
				variant="overline"
			/>
		);
	}
	return (
		<>
			<TextField
				{...props}
				emptyText="-"
				source="name"
				record={userPaymentRecord}
				label="resources.user-wtrs.fields.user_payment_id"
				className={classes.textField}
			/>
			<Typography className={classes.separator} component="span">
				/
			</Typography>
			<TextField
				{...props}
				emptyText="-"
				source="status.name"
				record={userPaymentRecord}
				className={classes.textField}
			/>
		</>
	);
};

export default UserPaymentField;
